<template>
  <div class="registration-window" id="login-window">
    <div class="registration-window-fl">
      <div class="registration-window-wrap">
        <router-link :to="{ name: 'home' }" class="registration-window-close"></router-link>

        <div class="registration-window-title">Вход</div>

        <div class="registration-window-log">
          <form @submit.prevent.stop="onSubmit(login, phone, password)">
            <div class="tt-tabs tabs-rwr">
              <div class="index-tabs">
                <span @click="this.tabActive = 0" :class="this.tabActive === 0 ? 'active-ttab' : ''">· По почте ·</span>
                <span @click="this.tabActive = 1" :class="this.tabActive === 1 ? 'active-ttab' : ''"
                  >· По телефону ·</span
                >
              </div>

              <div class="index-panel">
                <input type="hidden" name="is_ajax" value="1" />
                <input type="hidden" name="g-recaptcha-response" value="" />

                <div v-if="this.tabActive === 0" class="tt-panel">
                  <div class="rwr-line">
                    <input
                      type="text"
                      class="rwr-input"
                      placeholder="Логин или номер телефона"
                      name="login"
                      v-model="login"
                      required=""
                    />
                  </div>
                  <div class="rwr-line">
                    <input
                      :type="passwordFieldType"
                      class="rwr-input"
                      name="pass"
                      v-model="password"
                      placeholder="Пароль"
                      required=""
                    />
                    <i class="icp" @click="switchVisibility"></i>
                  </div>
                </div>
                <div v-if="this.tabActive === 1" class="tt-panel">
                  <div class="rwr-line">
                    <input type="text" class="rwr-input" placeholder="Телефон" name="phone" v-model="phone" required />
                  </div>
                </div>
              </div>
            </div>
            <div class="error-message" v-if="errorMessage">{{ errorMessage }}</div>
            <button type="submit" class="registration-btn" :disabled="!this.login || !this.password || this.isLoading">
              {{ this.isLoading ? 'Подождите...' : 'Вход' }}
            </button>
          </form>

          <socials />

          <div class="reg-label rwr-reg-label">
            <span><router-link :to="{ name: 'restore' }" class="open-restore">Забыли пароль?</router-link></span>
            <router-link :to="{ name: 'register' }" class="only-open-reg">Регистрация</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LOGIN, OPEN_GLOBAL_POPUP } from '@/store/actions.type'
import PlayLine from '@/components/PlayLine'
import Socials from '@/components/Socials'
import { useI18n } from 'vue-i18n'
import { toast } from 'vue3-toastify'

export default {
  name: 'Login',
  components: { PlayLine, Socials },
  data() {
    return {
      tabActive: 0,
      login: null,
      phone: null,
      password: null,
      isLoading: false,
      passwordFieldType: 'password',
      errorMessage: null,
    }
  },
  setup() {
    const { t, locale } = useI18n()
    return { t, locale }
  },
  methods: {
    onSubmit(login, phone, password) {
      this.errorMessage = null
      if (!this.isLoading) {
        this.isLoading = true

        this.$store
          .dispatch(LOGIN, { login, phone, password })
          .then(() => {
            this.locale = this.$store.getters.currentUser.profile.lang
            this.isLoading = false
            return this.$router.push({ name: 'home' })
          })
          .catch(res => {
            this.isLoading = false
            if (res.status === 401) {
              this.errorMessage = this.t(res?.data?.message)
            } else {
              toast.error(this.t(res?.data?.message))
            }
          })
      }
    },
    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
  },
  mounted() {
    this.$store.dispatch(OPEN_GLOBAL_POPUP, true)
  },
  unmounted() {
    this.$store.dispatch(OPEN_GLOBAL_POPUP, false)
  },
}
</script>
